import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../hooks/use-user';
import { UserRole, UserType } from '../../lib/interfaces/user';
import ProductsPage from './page';

const ProductsWrapper = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    if (user.userType !== UserType.Internal || user.userRole === UserRole.User) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  return (
    <div className="flex flex-col gap-5 h-full">
      <ProductsPage />
    </div>
  );
};

export default ProductsWrapper;
